<template>
  <div class="loading-screen" v-if="isPageLoading == true">
    <h2>Loading in GPR Report</h2>
    <div class="spinner-wrap">
      <md-progress-spinner :md-diameter="100" :md-stroke="10" md-mode="indeterminate"
        class="md-accent"></md-progress-spinner>
    </div>
  </div>
  <div class="md-layout project-page" v-else>
    <md-card class="md-layout-item md-size-90">
      <md-card-header class="gpr-over-view">
        <h4>Completed GPR Report</h4>
        <div class="d-flex">
          <div class="button-block">
            <router-link :to="{ name: 'Project', params: { id: project.project.id } }">
              <md-button class="md-sm md-info">Go back to project</md-button>
            </router-link>
          </div>
          <div class="button-block">
            <md-button class="md-sm md-info export-button" @click="getPDF">VIEW PDF</md-button>
          </div>
          <div class="button-block">
            <router-link :to="{
                name: 'GPR Report Edit',
                params: { id: project.project.id },
              }" v-if="gprAccess">
              <md-button class="md-sm md-info">Edit Report</md-button>
            </router-link>
          </div>
          <div class="button-block">
            <md-button class="md-sm md-info export-button" @click="openAddUser">Email GPR Report</md-button>
          </div>
        </div>

        <div class="button-block p-actions-wrapper">
          <div class="addUser send-gpr-report" v-if="showAddUser">
            <md-field>
              <label>Email</label>
              <md-input v-model="newUser.email" type="text"></md-input>
            </md-field>
            <md-button class="md-success md-sm" :disabled="clickedOnce" @click="handleAddUser">Send GPR
              Report</md-button>
          </div>
        </div>

        <md-progress-spinner v-if="isLoading == true" md-mode="indeterminate" class="md-accent gprv-spin"
          :md-diameter="30" :md-stroke="3"></md-progress-spinner>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <h5 class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 titles">Overview Info</h5>
          <div class="md-layout-item md-size-33 md-medium-size-100 md-small-size-100 info-item">
            <div class="subheading">ATS Number</div>
            <div class="title">{{project.ats_data.ats_number}}</div>
          </div>
          <div class="md-layout-item md-size-33 md-medium-size-100 md-small-size-100 info-item">
            <div class="subheading">Job Name</div>
            <div class="title">{{project.ats_data.job_name}}</div>
          </div>
          <div class="md-layout-item md-size-33 md-medium-size-100 md-small-size-100 info-item">
            <div class="subheading">Job Site Address</div>
            <div class="title">{{displayAddress(project.address)}}</div>
          </div>
          <div class="md-layout-item md-size-33 md-medium-size-100 md-small-size-100 info-item">
            <div class="subheading">Prepared For</div>
            <div class="title">
              {{ project.ats_company.name }} <br />
              <div v-if="project.facility && project.facility.name">
                <span v-if="project.facility && project.facility.name">({{ project.facility.name }})</span> <br />
                <span v-if="project.facility && project.facility.address">{{ displayAddress(project.facility.address)
                  }}</span>
              </div>
              <span v-if="!project.facility.address">{{ displayAddress(project.ats_company.address) }}</span>
            </div>
          </div>
          <div class="md-layout-item md-size-33 md-medium-size-100 md-small-size-100 info-item">
            <div class="subheading">Project Manager</div>
            <div class="title"> {{project.project_manager.name}} <br /> Email: {{project.project_manager.email}} <br />
              Phone: {{project.project_manager.phone}}</div>
          </div>
          <div class="md-layout-item md-size-33 md-medium-size-100 md-small-size-100 info-item">
            <div class="subheading">Site Contact</div>
            <div class="title">{{project.site_contact.name}} <br /> {{project.site_contact.phone}} <br />
              {{project.site_contact.email}}</div>
          </div>
          <div class="md-layout-item md-size-33 md-medium-size-100 md-small-size-100 info-item">
            <div class="subheading">PO Number</div>
            <div class="title">{{project.ats_data.purchase_order_number}}</div>
          </div>
          <div class="md-layout-item md-size-33 md-medium-size-100 md-small-size-100 info-item">
            <div class="subheading">Prepared By</div>
            <div class="title">{{project.gpr_report.user}}</div>
          </div>
          <div class="md-layout-item md-size-33 md-medium-size-100 md-small-size-100 info-item" />

        </div>
        <div class="md-layout">
          <h5 class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 titles">GPR Scanning Activity</h5>
          <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100 info-item">
            <div class="subheading">Activities</div>
            <p class="title" v-for="(act, index) in project.gpr_report.data.activities" :key="index">{{act}}</p>
          </div>
          <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100 info-item">
            <div class="subheading">Area of Work</div>
            <p class="title">{{project.gpr_report.data.area_of_work}}</p>
          </div>
          <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100 info-item">
            <div class="subheading">Observations/Other Notes</div>
            <p class="title">{{project.gpr_report.data.observations}}</p>
          </div>
          <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100 info-item">
            <div class="subheading">Tech Name</div>
            <p class="title">{{project.gpr_report.data.tech_name}}</p>
          </div>
          <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100 info-item">
            <div class="subheading">Customer Name</div>
            <p class="title">{{project.gpr_report.data.customer_name}}</p>
          </div>
          <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100 info-item">
            <!-- <div class="subheading">Customer Signature</div>-->
            <!-- <p class="title">{{project.gpr_report.data.customer_signature}}</p> -->
            <!-- <img v-bind:src="project.gpr_report.data.customer_signature" alt="" class="displayed-signature">-->
          </div>
        </div>
        <div class="md-layout">
          <h5 class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 titles">Locations</h5>
          <div v-for="(location, index) in project.locations" :key="location.id"
            class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100">
            <h3>ATS {{project.ats_data.ats_number}} - Location {{index + 1}}</h3>
            <h6>Files</h6>
            <div class="files-display" v-if="location.files && location.files.length">
              <div class="files-display-item" v-for="(f) in location.files" :key="f.key">
                <div class="fdi-wrap">
                  <!-- <md-icon class="remove" v-on:click.native="removeFile(f, index)">close</md-icon> -->
                  <img class="fdi-img" :src="f.url" v-lazy="f.url" :srcset="f.url" />
                  <!-- <md-button class="md-sm md-info" v-on:click="openPic(f.url)">Open Image</md-button> -->
                  <md-button class="md-sm md-info" v-on:click="openLightbox(`${location.id}-${f.filename}`)">Open
                    Image</md-button>
                </div>
              </div>
            </div>
            <h6>Summary</h6>
            <p>{{location.survey_summary}}</p>
            <h6>Other Notes</h6>
            <p>{{location.summary_notes}}</p>
            <h6>Barcode Number</h6>
            <p>{{location.barcode_number}}</p>
            <!-- <h6>Customer Signature</h6>
            <p>{{location.customer_signature}}</p> -->
            <md-divider />
          </div>

          <LightBox :showLightBox="showbox" :media="images" :key="index" :startAt="startAt" />

        </div>

      </md-card-content>
    </md-card>
  </div>
</template>
<script>
  // import {Collapse2} from '@/components'
  import api from '@/api';
  import idx from 'idx';
  import LightBox from 'vue-image-lightbox';
  // import 'vue-image-lightbox/dist/vue-image-lightbox.min.css';
  import VueLazyload from 'vue-lazyload';
  require('vue-image-lightbox/dist/vue-image-lightbox.min.css')
  export default {
    components: {
      LightBox
      // Collapse2
    },
    data(){
      return{
        project: {},
        isLoading: false,
        isPageLoading: true,
        message: '',
        activeImageIndex: null,
        showbox: false,
        images: [
          { // For image
            thumb: '',
            src: '',
            caption: '', // Optional
            srcset: '' // Optional for displaying responsive images
          },
        ],
        index: 0,
        startAt: 0,
        showAddUser: false,
        clickedOnce: false,
        newUser: {
          email: '',
        },
      }
    },
    mounted() {
      var projectId = this.$route.params.id;
      if (projectId == undefined) {
        this.$router.push("projectportal");
      } else {
        api.getProject(projectId).then((response) => {
          this.project = idx(response, _ => _.data);
          this.isLoading = false;
          this.isPageLoading = false;
          console.log(this.project)
          // this.message = `http://localhost:8080//api//gpr_reports/${this.project.gpr_report.data.id}.pdf`
          this.message = `http://localhost:8080//#/reports/${this.project.gpr_report.data.id}`
          // this.message = `http://localhost:8080/#/reports/${this.project.gpr_report.data.id}`
          var index = 0
          this.project.locations.forEach((location) => {
            location.files.forEach((file) => {
              const key = `${location.id}-${file.filename}`;
              file.srcset = file.url;
              file.src = file.url;
              file.thumb = file.url;
              file.id = key;
              index = index + 1;
              file.fileIndex = index;
              this.images.push(file)
            });
          })

        });
      }
    },
    computed: {
      gprAccess(){
        return this.$store.state.user.gpr_access;
      }
    },
    methods: {
      openAddUser() {
        this.showAddUser = !this.showAddUser;
      },
      handleAddUser() {
        console.log(this.newUser.email);
        this.clickedOnce = true;
        this.isLoading = true;
        if (this.newUser.email) {
          var data = {
            'email': this.newUser.email,
            'id': this.project.gpr_report.data.id
          }
          api.sendPDFEmail(data).then((response) => {
            this.clickedOnce = false;
            this.isLoading = false;
            console.log(response);
            //not sure if this will work in production
             this.notifyVue(
              "Sent PDF link to " + this.newUser.email,
            );
          });
        }
      },
      openLightbox(key) {
        const selectedImage = this.images.find(x => x.id === key);
        this.showbox = true; 
        this.startAt = selectedImage.fileIndex
        this.index = selectedImage.fileIndex + 1
      },
      displayAddress(address) {
        // console.log(address)
        // console.log(this.project.ats_data);
        for (const key in address) {
          if (address[key] == null){
            address[key] = ''
          }
        }
        var full_ad = address.street_address + ' ' + address.address_line_2 + ', ' + address.city + ', ' + address.state + ' ' + address.zip_code;
        return full_ad
        // return
      },
      getSlotName(index){
        return "md-collapse-pane-" + index.to_str
      },
      getPDF() {
        console.log(this.project.gpr_report)
        this.isLoading = true;
        api.getPDFLink(this.project.gpr_report.data.id).then((response) => {
          console.log(response);
          //not sure if this will work in production
          var full_url = response.config.baseURL + response.config.url
          window.open(full_url, "_self");
        })
      },
      onCopy: function (e) {
        this.notifyVue("You have copied this report's PDF link. Make sure the person you are sharing the PDF with has an account on SafeCore Systems.", "success")
      },
      onError: function (e) {
        this.notifyVue('Failed to copy link, please try again.', "danger")
      },
      notifyVue(message, color) {
        console.log('here2');
        console.log(this.$notify);
        // var color = Math.floor(Math.random() * 4 + 1);
        this.$notify({
          // timeout: 4000,
          message: message,
          horizontalAlign: 'left',
          verticalAlign: 'top',
          type: color
        });
      }
    }
  }
</script>
<style lang="scss">
.button-block{
  margin-right: 10px;
  margin-top: 10px;
}
@media (max-width: 991px) {
  .send-gpr-report{
    flex-direction: column;
  }
}

</style>
